import Axios from "axios";

export const Avatar = {

	selectors: {
		avatar: document.querySelector(
			".js-avatar"
		),
		imageContent: document.querySelector(
			".js-avatar-content"
		)
	},

	init: function() {

		let self = this;
		if (self.selectors.avatar) {
			self.selectors.avatar.addEventListener('change', event => {

				let file = event.target.files[0];

				if (file) {
					// grab the file
					let formData = new FormData();
					formData.append('file', file);

					Axios.post(self.selectors.avatar.dataset.url, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}).then(function (response) {
						self.selectors.imageContent.innerHTML = response.data.content;

					}).catch((error) => {
						alert(error.response.data.errors['file'][0]);
					});
				}
			});
		}
	},
};

Avatar.init();
